import axios from 'axios'

export const getHomeScreenDetails = async token => {
  const url = process.env.GATSBY_API_LOYALTY_APP

  const headers = {
    Authorization: `Bearer ${token}`,
    withCredentials: false,
    'x-functions-key': process.env.GATSBY_AZURE_FUNCTION_KEY,
    'Access-Control-Allow-Origin': '*'
  }
  const params = { op: 'getHomeScreenDetails' }

  const res = await axios({
    method: 'get',
    headers,
    url,
    params
  })

  return res.data
}
